import React, {useState} from 'react'
import '../Contact/Contact.css'
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaGlobe } from 'react-icons/fa';
import Connect from '../Connect/Connect';

const Contactmain = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNumber: '',
    packagingRequirements: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
  };

  const cardData = [
    { 
      id: 1, 
      heading: 'Head Office', 
      text: 'Sector-62, Noida, Uttar Pradesh 201301, India', 
      icon: <FaMapMarkerAlt /> 
    },
    { 
      id: 2, 
      heading: 'Enquiries', 
      text: '+91 00000 0000', 
      icon: <FaPhoneAlt /> 
    },
    { 
      id: 3, 
      heading: 'Support', 
      text: 'support@orthopack.com', 
      icon: <FaEnvelope /> 
    },
    { 
      id: 4, 
      heading: 'Website', 
      text: 'www.orthwebsite.com', 
      icon: <FaGlobe /> 
    },
  ];

  return (
    <>
      <div className='img-all-ca'>
        <div className='all-con-ca'>
          <div className='div-co-head-ca'>
            <div className="ribbon9-ca">Request Packaging Samples</div>
          </div>
          
          <div className="cards-container-ca">
            {cardData.map((card) => (
              <div className="card-ca" key={card.id}>
                <div className="card-icon-ca">{card.icon}</div>
                <h2 className="card-heading-ca">{card.heading}</h2>
                <p className="card-text-ca">{card.text}</p>
              </div>
            ))}
          </div>
          
          
        </div>
        
        <div className="wrapper-ca">
         <Connect/>
        </div>
      </div>
    </>
  )
}

export default Contactmain